import { createContext, useContext } from 'react';
import { PaymentFormHandle } from 'components/billing/PaymentForm/PaymentForm';

interface ICardInfoContext {
  cardInfoFormRef: React.RefObject<PaymentFormHandle> | null;
  setCardInfoFormRef: (ref: React.RefObject<PaymentFormHandle> | null) => void;
}

export const CardInfoContext = createContext<ICardInfoContext>({
  cardInfoFormRef: null,
  setCardInfoFormRef: () => {},
});

export const useCardInfoContext = () => useContext(CardInfoContext);
